import { Box } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more.js';
import Highcharts from 'highcharts/highstock';

highchartsMore(Highcharts);

export function DistributionConsolidated({ externalData, pasoId }) {
  const chartResponseTimeConsolidatedRef = React.useRef(null);
  const chartNodeRef = React.useRef(null);
  const containerRef = React.useRef(null);
  const { t } = useTranslation();

  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const resizeObserver = new ResizeObserver(() => {
      if (chartResponseTimeConsolidatedRef.current) {
        chartResponseTimeConsolidatedRef.current.chart.reflow();
      }
      if (chartNodeRef.current) {
        chartNodeRef.current.chart.reflow();
      }
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.unobserve(container);
    };
  }, []);

  function processData() {
    const data = externalData.Objetivo;
    var newSteps = data?.Paso.filter((i) => i.paso_id === parseInt(pasoId))[0] ?? null;
    var uptimePaso = 0;
    var downParcialPaso = 0;
    var downPaso = 0;
    var noMonPaso = 0;
    (newSteps?.estado ?? []).map((eventos) => {
      let dateHasta = new Date(eventos.fecha_hasta);
      let dateDesde = new Date(eventos.fecha_desde);
      let result = dateHasta - dateDesde;
      if (eventos.nombre === 'uptime') {
        uptimePaso = uptimePaso + result;
      } else if (eventos.nombre === 'downtime') {
        downPaso = downPaso + result;
      } else if (eventos.nombre === 'no monitoreo') {
        noMonPaso = noMonPaso + result;
      } else {
        downParcialPaso = downParcialPaso + result;
      }
    });

    var total = uptimePaso + downParcialPaso + downPaso + noMonPaso;
    var factor = 100 / total;
    var uptime = 0;
    var down = 0;
    var downParcial = 0;
    var noMon = 0;
    if (uptimePaso !== 0) {
      uptime = parseFloat((uptimePaso * factor).toFixed(2));
    }
    if (downParcialPaso !== 0) {
      downParcial = parseFloat((downParcialPaso * factor).toFixed(2));
    }
    if (downPaso !== 0) {
      down = parseFloat((downPaso * factor).toFixed(2));
    }
    if (noMonPaso !== 0) {
      noMon = parseFloat((noMonPaso * factor).toFixed(2));
    }
    return {
      chartOptions: {
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
        },
        credits: {
          enabled: false,
        },
        title: {
          text: t('distribution-consolidated.chart.title'),
          style: {
            color: '',
            fontWeight: '',
            fontSize: '',
          },
        },
        accessibility: {
          point: {
            valueSuffix: '%',
          },
        },
        tooltip: {
          pointFormat: '<b>{point.percentage:.1f}%</b>',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            dataLabels: {
              enabled: true,
              format: '{point.percentage:.2f}',
            },
            showInLegend: true,
          },
        },
        series: [
          {
            type: 'pie',
            data: [
              {
                name: t('distribution-consolidated.chart.series.uptime'),
                y: uptime,
                //sliced: true,
                //selected: true,
                legendColor: '#43a047',
                color: '#43a047',
                states: {
                  select: {
                    color: '#66bb6a',
                  },
                },
              },
              {
                name: t('distribution-consolidated.chart.series.partial'),
                y: downParcial,
                color: '#ffeb3b',
                legendColor: '#ffeb3b',
                states: {
                  select: {
                    color: '#ffee58',
                  },
                },
              },
              {
                name: t('distribution-consolidated.chart.series.downtime'),
                y: down,
                color: '#e53935',
                legendColor: '#e53935',
                states: {
                  select: {
                    color: '#f44336',
                  },
                },
              },
              {
                name: t('distribution-consolidated.chart.series.no-monitoring'),
                y: noMon,
                color: '#757575',
                legendColor: '#757575',
                states: {
                  select: {
                    color: '#9e9e9e',
                  },
                },
              },
            ],
          },
        ],
      },
      isLoad: false,
    };
  }

  const { chartOptions } = processData();

  return (
    <Box ref={containerRef} width="100%">
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        ref={chartResponseTimeConsolidatedRef}
        containerProps={{ style: { width: '100%' } }}
      />
    </Box>
  );
}
